import type { MyPlaceListItem } from "@/features/my/_types";

/** Shape of the `plan` payload on `/members/places` list items — typed `unknown` in the generated client. */
type MyPlacePlan = {
  isActive?: boolean | null;
};

function hasActiveMembership(place: MyPlaceListItem): boolean {
  const plan = place.plan as MyPlacePlan | null | undefined;
  return plan?.isActive === true;
}

/**
 * Pick the place to select when no valid stored placeId exists.
 * Prefers the first place with an active membership so members with access to
 * multiple households land on an active one, falling back to the first place.
 */
export function findDefaultPlace(
  places: MyPlaceListItem[],
): MyPlaceListItem | undefined {
  return places.find(hasActiveMembership) ?? places[0];
}
